import { firstValueFrom } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { ngHelper } from '@cakeiteasy/web-utils';

import { PaymentApiService } from '../../../api-services/services/payment-api.service';
import { PaymentStorageService } from '../../services/payment-storage.service';
import { PAYMENT_PERSON_TYPES, PAYMENT_PLATFORM_TYPES } from '../../payment.constants';
import { IPaymentInfo, IWebhookUrls } from '../..';
import { CartState } from '../../../cart';
import { IUser } from '../../../users';

@Component({
  standalone: false,
  selector: 'vipps-payment',
  templateUrl: './vipps-payment.component.html',
  styleUrls: ['./vipps-payment.component.scss']
})
export class VippsPaymentComponent implements OnInit, OnChanges {
  @Input() personType: string;
  @Input() user: IUser;
  @Input() countryCode: string;
  @Input() webhookUrls: IWebhookUrls;
  @Input() giftCardCode: string = null;

  @Output() onTermsClick = new EventEmitter<void>();
  @Output() onSuccess = new EventEmitter<string>();
  @Output() onFail = new EventEmitter<any>();
  @Output() onError = new EventEmitter<any>();
  @Output() onOrderCreate = new EventEmitter<{ paymentId: number; sid: string; token: string; url: string; }>();

  public info: IPaymentInfo;
  public PAYMENT_PERSON_TYPES = PAYMENT_PERSON_TYPES;
  public alreadySubscriber: boolean = false;
  public paymentLoading: Promise<any>;
  public isValid: boolean;

  constructor(private _paymentApi: PaymentApiService,
              private _storage: PaymentStorageService,
              private _store: Store<CartState>) {
  }

  ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    const { directVipps } = PAYMENT_PLATFORM_TYPES;
    ngHelper.ifChanged(changes, 'user', (user: IUser, prevUser: IUser) => {
      if (user) {
        if (user.subscribedOnNews) {
          this.alreadySubscriber = true;
        }
        this._storage.updateContactInfo(directVipps, null, user);
      }
      this.info = this._storage.getContactInfo(directVipps);
    });
  }

  public submit($event) {
    const payload = this._getPaymentPayload(this.info, this.giftCardCode);

    return this.paymentLoading = firstValueFrom(this._paymentApi
      .createVippsPayment(payload))
      .then((data: { paymentId: number; sid: string; token: string; url: string; }) => {
        this.onOrderCreate.emit(data);
      })
      .catch((err) => {
        this.onFail.emit(err);
      });
  }

  public newsletterUpdate(isSubscribed: boolean) {
    const { directVipps } = PAYMENT_PLATFORM_TYPES;
    this.info.subscribedOnNews = isSubscribed;
    this._storage.updateContactInfo(directVipps, this.info);
  }

  public onInfoUpdated(paymentInfo: IPaymentInfo) {
    const { directVipps } = PAYMENT_PLATFORM_TYPES;
    this.info = { ...this.info, ...paymentInfo };
    this._storage.updateContactInfo(directVipps, this.info);
  }

  private _getPaymentPayload(info: IPaymentInfo, code?: string) {
    const payload = { ...info, code };

    if (this.personType === PAYMENT_PERSON_TYPES.PRIVATE) {
      delete payload.userCompanyName;
    }

    return {
      ...payload,
      ...this.webhookUrls
    };
  }
}
